<!-- 首页的评论模块 -->
<template>
  <div class="comment-col">
    <!-- 标题 -->
    <div
      v-if="moduleConfig.title"
      class="comment-col__title home-title title_font"
      :style="{
        textAlign: moduleConfig.align,
      }"
    >
      {{ moduleConfig.title }}
    </div>

    <!-- 评论 -->
    <div class="comment-col__average-rating">
      <v-comments-star :disabled="true" :average_rating="avgRating" />
      <span class="average-rating__text secondary_title">
        {{ data.length }} {{ $t('comment.reviews') }}
      </span>
    </div>

    <v-comments-waterfall
      class="comment-col__waterfall"
      comment_mode="page"
      :comment="commentConfig"
      :new_comments_list="comment.data"
      @cardClick="handleCardClick"
      :comment_info="moduleConfig"
      :style="{
        '--comment-mobile-col': moduleConfig.mobile_row_amount || 2,
      }"
    ></v-comments-waterfall>

    <div class="comment-col__btn-wrapper">
      <a
        v-if="
          moduleConfig.show_more_button &&
          comment.data.length < moduleConfig.count &&
          comment.data.length < comment.total
        "
        class="home-btn secondary_title"
        :class="{
          'button--loading': loading,
        }"
        :style="{
          '--btn-bg-color': moduleConfig.button_background_color,
          '--btn-color': moduleConfig.button_text_color,
        }"
        @click="fetchMore"
      >
        {{ $t('comment.show_more_reviews') }}
      </a>
      <a
        v-if="customButtom.show && customButtom.text"
        class="home-btn secondary_title"
        :href="customButtom.url"
        :style="{
          '--btn-bg-color': moduleConfig.button_background_color,
          '--btn-color': moduleConfig.button_text_color,
        }"
      >
        {{ customButtom.text }}
      </a>
    </div>
  </div>
</template>

<script>
import vCommentsWaterfall from '@/js/components/view/comments/commentsUl_waterfall.vue'
import vCommentsModal from '@/js/components/view/comments/commentModal.vue'
import vCommentsStar from '@/js/components/view/comments/commentsstar.vue'

export default {
  name: 'commentColCard',
  components: {
    vCommentsWaterfall,
    vCommentsModal,
    vCommentsStar,
  },
  props: {
    // 模块设置
    moduleConfig: {
      type: Object,
      default: {},
    },
    // 评论配置
    commentConfig: {
      type: Object,
      default: {},
    },
    // 评论数据的全部数据
    data: {
      type: Array,
      require: true,
    },
    // loading
    loading: {
      type: Boolean,
      default: false,
    },
    // 平均值
    avgRating: {
      type: Number,
      default: 0,
    },
  },
  emits: ['openModal'],
  data() {
    return {
      comment: {
        data: [],
        page: 1,
        pageSize: 10,
        total: 0,
      },
      showMore: false,
      error: null,
      modal_index: null,
      comment_item: {},
      customButtom: {
        show: this.moduleConfig?.show_custom_button?.show || false,
        text: this.moduleConfig?.show_custom_button?.text || null,
        url: this.moduleConfig?.show_custom_button?.url || null,
      },
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    // 获取博客数据
    // 全部返回
    fetch() {
      if (this.data.length === 0) {
        return
      }
      // 截取数据, 最后一页可能没有满
      this.comment.total = this.data.length

      // 截取数据, 如 0~19， 20~39
      const start = (this.comment.page - 1) * this.comment.pageSize
      const end = this.comment.page * this.comment.pageSize

      const newCommentData = this.data?.slice(start, end)

      const commentData = this.comment.data.concat(newCommentData)
      this.comment.data = commentData
    },
    // 加载更多
    fetchMore() {
      if (this.loading) return

      if (this.comment?.data?.length >= this.moduleConfig?.count || this.comment.total <= this.comment?.data?.length) {
        return
      }

      this.comment.page = this.comment.page + 1

      this.fetch()
    },
    handleCardClick(index, val) {
      // (val) => $emit('click', val)
      this.$emit('openModal', index, val)
    },
    changeModalIndex(index) {
      this.modal_index = index
    },
  },
}
</script>

<style lang="scss">
.comment-col {
  &__waterfall {
    li {
      &:nth-child(1) {
        .detail {
          padding-bottom: 1px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.comment-col {
  &__waterfall {
    margin-top: -10px;
  }
  &__average-rating {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .average-rating {
      &__rate {
        font-size: 22px;
      }
      &__text {
        margin-left: 8px;
        margin-top: 6px;
      }
    }
  }
  &__btn-wrapper {
    text-align: center;
    margin-top: 20px;
    a {
      margin-left: 8px;
      margin-right: 8px;
    }
  }

  .button {
    &--loading {
      cursor: auto;
      position: relative;
      overflow: hidden;
      &::before {
        display: inline-block;
        content: '';
        position: absolute;
        z-index: 1;
        height: 100%;
        width: 100%;
        background-color: #00000035;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
      &::after {
        content: '';
        top: 50%;
        left: 50%;
        margin-top: -12px;
        margin-left: -12px;
        height: 24px;
        width: 24px;
        border-radius: 50vh;
        position: absolute;
        border-color: #fff;
        border-width: 2px;
        border-style: solid;
        border-top-color: transparent;
        animation: spin 1s infinite linear;
        z-index: 2;
      }
    }
  }

  @media screen and (max-width: 767px) {
    &__waterfall {
      column-count: var(--comment-mobile-col);
    }
  }
}
</style>
